import { Breadcrumb } from 'react-breadcrumbs';
import { Helmet } from 'react-helmet-async';

import EmailTemplateCreateForm from './EmailTemplateCreateForm';
import Flash from '../../../library/utils/Flash';
import LoadingSpinner from '../../../library/utils/LoadingSpinner';
import Section from '../../../library/layout/Section';
import useQueryState from '../../../../hooks/use-query-state';
import { useEmailTemplate } from '../../../../hooks/queries/email-templates';
import { correctPath } from 'libraries/gem';

const EmailTemplateCreate = () => {
  const [baseId] = useQueryState<string>('base', '');
  const {
    error: baseTemplateError,
    isLoading: isBaseTemplateLoading,
  } = useEmailTemplate(baseId);

  if (baseId && isBaseTemplateLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Breadcrumb
      data={{
        title: 'Create',
        pathname: correctPath('/app/email-templates/create'),
      }}
    >
      <Section
        className="email-template-create-container"
        title="Create a new email template"
      >
        <Helmet>
          <title>Create Email Template | Gem Scheduling</title>
        </Helmet>
        <div className="email-template-create-steps-container">
          {baseTemplateError ? (
            <Flash
              message={baseTemplateError?.message}
              showFlash={Boolean(baseTemplateError)}
              type="danger"
            />
          ) : (
            <EmailTemplateCreateForm />
          )}
        </div>
      </Section>
    </Breadcrumb>
  );
};

export default EmailTemplateCreate;
